import Actions from '../constants/Actions';
const TIMEOUT = 20000;

const EntertainerLoadCreator = {
  loadResultsPage(context, {id}, done) {
    context.service.read('entertainerservice', {
        id
      }, {
        timeout: TIMEOUT
      },
      (err, data) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_RESULTS_SUCCESS, data);
        done();
      }
    );
  },
  loadOffersPage(context, {id}, done) {
    context.service.read('offerservice', {
        id
      }, {
        timeout: TIMEOUT
      },
      (err, data) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_OFFERS_SUCCESS, data);
        done();
      }
    );
  },
};

export default EntertainerLoadCreator;



// WEBPACK FOOTER //
// ./src/actions/EntertainerLoadCreator.js